import { Col, Input, Radio, Row } from "antd"

export const Observaciones = ({observaciones, setObservaciones ,cumpleRequisitos ,setCumpleRequisitos } : any) => {
  return (
    <Row>
      <Col span={24}>
        <Input.TextArea rows={8} value={observaciones} onChange={(e) => setObservaciones(e.target.value)}></Input.TextArea>
      </Col>
      <Col span={24}>
        <div>¿Cumple con los requisitos para ser jurado?</div>
        <Radio.Group onChange={(e) => setCumpleRequisitos(e.target.value)} value={cumpleRequisitos}>
          <Radio value={true}>Sí</Radio>
          <Radio value={false}>No </Radio>
        </Radio.Group>
      </Col>
    </Row>
  )
}
